import type { SyncHasMany } from "@ember-data/model";
import type DefaultBioExamModel from "parog-web/models/default-bio-exam";
import type Patient from "parog-web/models/patient";

export default function bioExamResultsFilter(
  patient: Patient,
  bioExams:
    | DefaultBioExamModel[]
    | SyncHasMany<DefaultBioExamModel>
    | undefined
    | null
): DefaultBioExamModel[] {
  if (!bioExams) return [];

  if (patient.isProIrc) {
    return bioExams.slice().filter(be =>
      [
        "62238-1", // DFG CKD EPI
        "14682-9", // Créatinémie
        "2000-8", // Calcium
        "14879-1", // Phosphore
        "1751-7", // Albumine
        "1963-8", // Bicarbonate
        "2888-6", // Protéinurie sur 24h
        "34366-5", // Protéinurie / Créatinurie
        "32294-1", // Albuminurie
        "4548-4", // HBA1C
        "2823-3", // Pottassium,
        "718-7", // Hémoglobine
        "2956-1", // Urée sur 24h
        "25550-5" // Sodium sur 24h
      ].includes(be.id)
    );
  }

  return bioExams.slice();
}
